import classes from "./ModalHeader.module.css";
import { CloseIcon } from "../../images/deliveries/deliveriesModals/xIcon";
import { useSelector } from "react-redux";

export function ModalHeader({
  title,
  onClick,
  resetButton = [],
  closeButton = true,
  headerWidth,
}) {
  const { isEditMode, isMapShown, isDriverInfoShown, isGenerateApiShown } =
    useSelector((s) => s.global);

  const shouldSpaceBetween =
    !isEditMode && !isMapShown && !isDriverInfoShown && !isGenerateApiShown;

  return (
    <div className={classes.container}>
      <h6 style={{ width: headerWidth ? headerWidth : "" }}>{title}</h6>
      <div
        className={classes.actions}
        style={{
          justifyContent: shouldSpaceBetween ? "space-between" : "end",
        }}
      >
        {resetButton && !isEditMode && resetButton}
        {closeButton && <CloseIcon onClick={onClick} />}
      </div>
    </div>
  );
}
